import {useSelector, TypedUseSelectorHook} from 'react-redux';
import {store} from './store';

export type RootState = ReturnType<typeof store.getState>;
export const useAppSelector: TypedUseSelectorHook<any> = useSelector;
export const useTypedAppSelector: TypedUseSelectorHook<RootState> = useSelector;
